var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFleche(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 6,
    viewBox: "0 0 17 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_222",
    "data-name": "Groupe 222",
    transform: "translate(-1021.5 -532.586)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_16",
    "data-name": "Ligne 16",
    x2: 14,
    transform: "translate(1021.5 535.5)",
    fill: "none",
    stroke: "#212121",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_1",
    "data-name": "Polygone 1",
    d: "M3,0,6,5H0Z",
    transform: "translate(1038.5 532.586) rotate(90)",
    fill: "#212121"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFleche);
export default __webpack_public_path__ + "static/media/icon-fleche.a6d03c65e32422ed2b86b62a4c6547a1.svg";
export { ForwardRef as ReactComponent };